import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/AIGC/QRaigc.png'


const _hoisted_1 = { class: "aigcmodel" }
const _hoisted_2 = { class: "warp" }
const _hoisted_3 = { class: "model" }
const _hoisted_4 = { class: "model-warp" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "close-circle",
  class: "anticon anticon-close-circle"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "close-circle",
    width: "25px",
    height: "25px",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" })
  ])
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "model-cont" }, [
  /*#__PURE__*/_createElementVNode("span", null, " 请添加IDP LM专属客服咨询详情 "),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "icon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeAigcStatus(false)))
          }, _hoisted_6),
          _hoisted_7
        ])
      ])
    ])
  ]))
}